import React, { createContext, useContext, useState, useEffect } from "react";
import { getCurrentUser, isAuthenticated, logoutUser } from "../services/authService";

// Create the AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const user = getCurrentUser();
        setCurrentUser(user);
        setIsLoggedIn(isAuthenticated());
    }, []);

    const logout = () => {
        logoutUser();
        setCurrentUser(null);
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ currentUser, isLoggedIn, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
